import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import BundleCreateForm from "../-form";
import { BundleCrumbs } from "../-crumbs";
import { getGetBundleQueryOptions } from "@/requests/gen/react-query/bundle";
import numericId from "@/lib/numeric-id";

export const Route = createFileRoute(
  "/_private/_patient-360/bundle/$bundleId/edit",
)({
  loader: ({ context: { queryClient }, params: { bundleId } }) =>
    queryClient.ensureQueryData(getGetBundleQueryOptions(numericId(bundleId))),
  component: BundleEditPage,
});

function BundleEditPage() {
  const { bundleId } = Route.useParams();
  const bundle = useSuspenseQuery(
    suspenseOptions(getGetBundleQueryOptions(numericId(bundleId))),
  );

  return (
    <div>
      <title>
        {`${bundle.data?.name || "Edit Bundle"} - Legrande Health Portal`}
      </title>
      <BundleCrumbs />
      <Card>
        <CardHeader>
          <CardTitle>Edit Bundle</CardTitle>
          <CardDescription>Update bundle details below.</CardDescription>
        </CardHeader>
        <CardContent>
          {bundle.data && <BundleCreateForm bundle={bundle.data} />}
        </CardContent>
      </Card>
    </div>
  );
}
